import {AUTH} from '../../actions/auth/authActionTypes';

const INITIAL_STATE = {
  signInError: {},
  signUpError: {},
  passRecoveryError: {}
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH.SIGN_IN_FAIL:
      return {...state, signInError: action.error.response.data};
    case AUTH.SIGN_UP_FAIL:
      return {...state, signUpError: action.payload.signUpError};
    case AUTH.PASS_RECOVERY_FAIL:
      return {...state, passRecoveryError: action.error.response.data};
    default:
      return state;
  }
}
